import get from 'lodash/get'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Single from './Single'
import Shared from './Shared'
import PriceSection from './PriceSection'
import PropTypes from 'prop-types'

export default function Notification({
  product,
  isUpgraded,
  isShared,
  setIsCollapsed,
  numberOfProducts,
  currency,
  updateShared,
  occupancy,
  maxOccupancy,
  isShareable,
}) {
  const roomTitle = get(product, 'room.roomCategory.title', '')
  const numberOfGuests = get(product, 'room.totalGuests')
  const isApplySingle = !isShareable && maxOccupancy > 1

  const sharedHandler = (isShared) => {
    setIsCollapsed(true)
    updateShared(product, false, isShared)
  }

  useEffect(() => {
    updateShared(product, true, !isShared)
  }, [])

  const getHeader = () => {
    if(isUpgraded) {
      return (
        <FormattedMessage
          id='switch_back_to_shared'
          defaultMessage='Would you like to switch back to SHARED OCCUPANCY?'
        />
      )
    } else if(isApplySingle) {
      return (
        <FormattedMessage
          id='single_occupancy_was_applied'
          defaultMessage='Single occupancy price was applied'
        />
      )
    } else if(isShared) {
      return (
        <FormattedMessage
          id='upgrade_to_single_occupancy'
          defaultMessage='Would you like to upgrade to SINGLE OCCUPANCY?'
        />
      )
    }
  }

  return (
    <div>
      <div className='upgrade'>
        {isApplySingle && (
          <div className='close-btn' onClick={() => setIsCollapsed(true)}>
            <i className='font-icons close-icon' />
          </div>
        )}
        {numberOfProducts > 1 && (
          <p className='title text-uppercase'>{roomTitle}</p>
        )}
        <p>{getHeader()}</p>
        <PriceSection
          product={product}
          currency={currency}
          occupancy={occupancy}
          isApplySingle={isApplySingle}
        />
      </div>
      {isShared ? (
        <Shared
          roomTitle={roomTitle}
          numberOfProducts={numberOfProducts}
          setIsCollapsed={setIsCollapsed}
          numberOfGuests={numberOfGuests}
          sharedHandler={sharedHandler}
          isShareable={isShareable}
        />
      ) : (
        <Single
          sharedHandler={sharedHandler}
          setIsCollapsed={setIsCollapsed}
          isApplySingle={isApplySingle}
        />
      )}
    </div>
  )
}

Notification.propTypes = {
  product: PropTypes.object,
  isUpgraded: PropTypes.bool,
  isShared: PropTypes.bool,
  setIsCollapsed: PropTypes.func,
  numberOfProducts: PropTypes.number,
  currency: PropTypes.string,
  updateShared: PropTypes.func,
  occupancy: PropTypes.array,
  maxOccupancy: PropTypes.number,
  isShareable: PropTypes.bool,
}
